import BrandForm from "./BrandForm";

export default function CreateBrand() {
  return (
    <>
      <h3>Create Brand</h3>
      <BrandForm
        model={{ name: "" }}
        onSubmit={async (value) => {
          //when form is posted
          await new Promise((r) => setTimeout(r, 1));
          console.log(value);
        }}
      />
    </>
  );
}
